import imgTSCA from '@/assets/images/TSCA.webp';
import imgCARB from '@/assets/images/carb.webp';
import styles from './ProductCertifications.module.scss';

const CERTIFICATIONS = [
  {
    image: imgTSCA,
    alt: 'TSCA EPA Title VI Certified logo',
    title: 'TSCA EPA Title VI Certified',
    description:
      'Compliant with EPA TSCA Title VI formaldehyde emission standards for composite wood products.',
  },
  {
    image: imgCARB,
    alt: 'CARB Phase 2 Compliant logo',
    title: 'CARB Phase 2 Compliant',
    description:
      'Compliant with California Air Resources Board Phase 2 formaldehyde emission standards.',
  },
];

/** Universal certification badges shown on every product page — not product-specific data. */
const ProductCertifications = () => (
  <section
    className={styles['certifications-section']}
    aria-labelledby="product-certifications-title"
    data-motion="section"
  >
    <h2 id="product-certifications-title" className={styles['certifications-title']}>
      Certifications
    </h2>
    <div className={styles['certifications-grid']}>
      {CERTIFICATIONS.map(cert => (
        <div key={cert.title} className={styles['certification-card']}>
          <img
            className={styles['certification-card__logo']}
            src={cert.image}
            alt={cert.alt}
            referrerPolicy="no-referrer"
          />
          <div className={styles['certification-card__body']}>
            <h3 className={styles['certification-card__title']}>{cert.title}</h3>
            <p className={styles['certification-card__description']}>{cert.description}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default ProductCertifications;
